export default {
    PAGE: {
        PFLANZGENEHMIGUNGEN: {
            INDEX: '/pflanzgenehmigungen',
        },
    },
    API: {
        PFLANZGENEHMIGUNGEN: '/betrieb/:betrieb_nr/rebflaeche/pflanzgenehmigung/guthaben',
    },
};
